/* js/videoGal.js */

jQuery( document ).ready(function( $ ) {

    $('.js-vidSwitcher-trigger').click(function () {

        var mainVid = $('.js-vidSwitcher-target').find('iframe').attr('src');

        var vidSrc = $(this).find('iframe').attr('src');



        //$(this).find('iframe').attr('src', "");

        $(this).find('iframe').attr('src', mainVid);


        //$('.js-vidSwitcher-target').find('iframe').attr('src', vidSrc + "&autoplay=1");
        $('.js-vidSwitcher-target').find('iframe').attr('src', vidSrc );

    });

});




